import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const BUYERS = [{
  name: 'María',
  city: 'Sevilla',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Claudia',
  city: 'CDMX',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Andrea',
  city: 'Bogotá',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Lucía',
  city: 'Buenos Aires',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Valentina',
  city: 'Lima',
  avatar: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Camila',
  city: 'Santiago',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Isabella',
  city: 'Medellín',
  avatar: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=80&h=80&fit=crop&crop=face'
}, {
  name: 'Sofía',
  city: 'Madrid',
  avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&fit=crop&crop=face'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const isVisibleRef = useRef(isVisible);
  isVisibleRef.current = isVisible;
  useEffect(() => {
    const cycleInterval = setInterval(() => {
      if (!isVisibleRef.current) {
        setCurrentBuyer(BUYERS[Math.floor(Math.random() * BUYERS.length)]);
        setMinutesAgo(Math.floor(Math.random() * 15) + 1);
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }, 4000);
    return () => clearInterval(cycleInterval);
  }, []);
  return <AnimatePresence data-id="element-241">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 flex max-w-xs items-center gap-3 rounded-xl bg-white p-3 shadow-lg border border-gray-100" data-id="element-242">
          <div className="relative h-12 w-12 flex-shrink-0 overflow-hidden rounded-full bg-gray-100" data-id="element-243">
            <img src={currentBuyer.avatar} alt={currentBuyer.name} className="h-full w-full object-cover" loading="lazy" data-id="element-244" />
            <div className="absolute bottom-0 right-0 h-3 w-3 rounded-full bg-rose-500 ring-2 ring-white" data-id="element-245"></div>
          </div>
          <div className="flex flex-col" data-id="element-246">
            <p className="text-sm font-medium text-gray-900" data-id="element-247">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-248">
              acaba de adquirir el Protocolo Calma-5™
            </p>
            <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-249">
              hace {minutesAgo} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}